/**
 * Quiz Selection Module Quiz Selection Module
 *
 * @module views/components/QuizSelection
 * @memberof -Common
 */
import './QuizSelection.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import GridContainer from '@ulta/core/components/GridContainer/GridContainer';
import Icon from '@ulta/core/components/Icon/Icon';
import Image from '@ulta/core/components/Image/Image';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Text from '@ulta/core/components/Text/Text';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * QuizCount to get the number of quiz selections being displayed
 *
 * @method
 * @param {object} data - All of the article data passed through
 * @returns The article
 */

export const QuizCount = ( length ) => {
  switch ( length ){
    case 1:
      return 'One';
    case 2:
      return 'Two';
    case 3:
      return 'Three';
    case 4:
      return 'Four';
    case 5:
      return 'Five';
    case 6:
      return 'Six';
    case 7:
      return 'Seven';
    case 8:
      return 'Eight';
    case 9:
      return 'Nine';
    case 10:
      return 'Ten';
    default:
      return 'None';
  }
};

/**
  * Represents a QuizSelection component
  *
  * @method
  * @param {QuizSelectionProps} props - React properties passed from composition
  * @returns QuizSelection
  */
export const QuizSelection = function( props ){
  const titleProps = props.title;
  const descriptionProps = props.description;
  return (
    <div className={
      classNames( 'QuizSelection', {
        [`QuizSelection__numQuiz--0${props.items.length}`]:props.items
      } )
    }
    >
      <GridContainer>
        {
          ( titleProps || descriptionProps ) &&
          <div className='QuizSelection__header'>
            {
              titleProps &&
              <div className='QuizSelection__title'>
                <Text
                  htmlTag={ titleProps.htmlTag }
                  textStyle={ titleProps.textStyle }
                  color={ titleProps.color }
                  textAlign={ titleProps.textAlign || 'center' }
                >
                  { titleProps.text }
                </Text>
              </div>
            }
            {
              descriptionProps &&
              <div className='QuizSelection__subtitle'>
                <Text
                  htmlTag='p'
                  textStyle='subtitle-2'
                  textAlign='center'
                >
                  { descriptionProps }
                </Text>
              </div>
            }
          </div>
        }
      </GridContainer>
      <GridContainer>
        <ul className='QuizSelection__group'>
          { props.items.map( ( item, index ) => (
            <li className={ classNames( `QuizSelection__item QuizSelection__${ QuizCount( props.items.length ) }Card--0${ index }` ) }
              key={ index }
            >
              <div className='QuizSelection__item__wrapper'>
                <Link_Huge
                  primary
                  target='_self'
                  action={ item.linkAction }
                >
                  <div className='QuizSelection__image'>
                    <Image
                      src={ item.image.imageUrl }
                      alt={ item.altText || item.image.altText || '' }
                      {
                        ...spreadProps( {
                          metaData: item.image.metaData
                        } )
                      }
                    />
                  </div>
                  {
                    ( item.linkAction?.label ) &&
                    <div className='QuizSelection__action'>
                      <div className='Link_Container'>
                        <Text
                          htmlTag='span'
                          textStyle='body-1'
                        >
                          { item.linkAction.label }
                        </Text>
                        <span className='QuizSelection__action--icon'>
                          <Icon
                            size='s'
                            name='ArrowForward'
                            aria-hidden={ true }
                          />
                        </span>
                      </div>
                    </div>
                  }
                </Link_Huge>
              </div>
            </li>
          ) ) }
        </ul>
      </GridContainer>
    </div>
  );
};

/**
   * Property type definitions
   * @typedef QuizSelectionProps
   * @type {object}
   * @property {object} title - Sets the title properties
   * @property {string} description - Sets the description
   * @property {array} items - Sets the items
   */

export const propTypes = {
  title: PropTypes.object,
  description: PropTypes.string,
  items: PropTypes.array
};

QuizSelection.propTypes = propTypes;

export default QuizSelection;
